<mic-spinner-overlay [loading]="loading" color="primary" [diameter]="40" ariaLabel="Processando solicitação">
  <div class="mandatory-dialog">
    <ng-container *ngIf="mode === 'reset'; else verificationError">
      <header class="dialog-header">
        <div class="header-icon"><mat-icon>lock_reset</mat-icon></div>
        <div>
          <p>Segurança da conta</p>
          <h2>Crie uma nova senha</h2>
        </div>
      </header>

      <p class="dialog-description">
        Sua senha atual é temporária ou precisa ser atualizada. Altere-a para continuar usando o portal.
      </p>

      <form [formGroup]="passwordForm" (ngSubmit)="resetPassword()" novalidate>
        <div class="form-field">
          <label for="mandatoryOldPassword">Senha atual</label>
          <div class="password-input">
            <input id="mandatoryOldPassword" [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword" autocomplete="current-password" />
            <button type="button" (click)="showOldPassword = !showOldPassword" [attr.aria-label]="showOldPassword ? 'Ocultar senha atual' : 'Mostrar senha atual'">
              <mat-icon>{{ showOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="passwordForm.get('oldPassword')?.touched && passwordForm.get('oldPassword')?.hasError('required')">Informe sua senha atual.</span>
          <span class="field-error" *ngIf="passwordForm.get('oldPassword')?.touched && passwordForm.get('oldPassword')?.hasError('invalidCurrentPassword')">Senha atual incorreta.</span>
        </div>

        <div class="form-field">
          <label for="mandatoryNewPassword">Nova senha</label>
          <div class="password-input">
            <input id="mandatoryNewPassword" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" autocomplete="new-password" (focus)="newPasswordActive = true" />
            <button type="button" (click)="showNewPassword = !showNewPassword" [attr.aria-label]="showNewPassword ? 'Ocultar nova senha' : 'Mostrar nova senha'">
              <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.hasError('required')">Informe a nova senha.</span>
          <span class="field-error" *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.hasError('passwordUnchanged')">A nova senha deve ser diferente da atual.</span>
          <app-password-rules [value]="passwordForm.get('newPassword')?.value" [active]="newPasswordActive"></app-password-rules>
        </div>

        <div class="form-field">
          <label for="mandatoryConfirmPassword">Confirmar nova senha</label>
          <div class="password-input">
            <input id="mandatoryConfirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" autocomplete="new-password" />
            <button type="button" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="showConfirmPassword ? 'Ocultar confirmação de senha' : 'Mostrar confirmação de senha'">
              <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.hasError('required')">Confirme a nova senha.</span>
          <span class="field-error" *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.hasError('passwordMismatch')">As senhas não coincidem.</span>
        </div>

        <div class="error-message" *ngIf="errorMessage" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>{{ errorMessage }}</span>
        </div>

        <button class="primary-button" type="submit" [disabled]="loading">
          <mat-icon>lock_reset</mat-icon>
          Alterar senha e continuar
        </button>
      </form>
    </ng-container>

    <ng-template #verificationError>
      <div class="verification-error">
        <div class="header-icon header-icon--error"><mat-icon>shield</mat-icon></div>
        <h2>Verificação necessária</h2>
        <p>{{ errorMessage }}</p>
        <button class="primary-button" type="button" [disabled]="loading" (click)="retryVerification()">
          <mat-icon>refresh</mat-icon>
          Tentar novamente
        </button>
        <button class="secondary-button" type="button" [disabled]="loading" (click)="logout()">
          <mat-icon>logout</mat-icon>
          Sair
        </button>
      </div>
    </ng-template>
  </div>
</mic-spinner-overlay>